import axios from 'axios';
import { HedisMetricsTypeEnum } from '../../Enum/HedisMetricsTypeEnum';
import { TimePeriodFilterEnum } from '../../Enum/TimePeriodFilterEnum';
import { apiString as api } from '../../utils/constants';

export const getDateFilter = function () {
    let dateList = [];
    dateList.push({ Id: 6, Value: 'Current Month' });
    dateList.push({ Id: 5, Value: 'Last 1 Month' });
    dateList.push({ Id: 1, Value: 'Last 3 Months' });
    dateList.push({ Id: 2, Value: 'Last 6 Months' });
    dateList.push({ Id: 3, Value: 'Last 1 Year' });
    dateList.push({ Id: 4, Value: 'Custom' });
    return dateList;
};

export const getBpSummary = async (
    healthPlanIds: string,
    population: number,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbpsummary?healthPlanIds=${healthPlanIds}&population=${population}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getBpMembers = async (
    healthPlanIds: string,
    population: number,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbpmembers?healthPlanIds=${healthPlanIds}&population=${population}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getAdultHealthSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getadulthealthsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getAdultHealthMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getadulthealthmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getBmiSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbmisummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getBmiMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbmimembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getBreastCancerScreeningSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbreastcancerscreeningsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getBreastCancerScreeningMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbreastcancerscreeningmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getHgbA1CSummary = async (
    healthPlanIds: string,
    population: number,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/gethgba1csummary?healthPlanIds=${healthPlanIds}&population=${population}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getHgbA1CMembers = async (
    healthPlanIds: string,
    population: number,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/gethgba1cmembers?healthPlanIds=${healthPlanIds}&population=${population}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getDiabeticEyeExamSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getdiabeticeyeexamsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getDiabeticEyeExamMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getdiabeticeyeexammembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getMedicationReconciliationSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getmedicationreconciliationsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getMedicationReconciliationMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getmedicationreconciliationmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getDepressionScreeningSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getdepressionscreeningsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getDepressionScreeningMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getdepressionscreeningmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getDepressionFollowUpSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getdepressionsfollowupsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getDepressionFollowUpMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getdepressionfollowupmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getLipidForBHDXSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getlipidforbhdxsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getLipidForBHDXMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getlipidforbhdxmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getHgbA1CForBHDXSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/gethgba1cforbhdxsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getHgbA1CForBHDXMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/gethgba1cforbhdxmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getCervicalCancerScreeningSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getcervicalcancerscreeningsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getCervicalCancerScreeningMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getcervicalcancerscreeningmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getColorectalCancerScreeningSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getcolorectalcancerscreeningsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getColorectalCancerScreeningMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getcolorectalcancerscreeningmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const exportHedisDetail = async (
    type: HedisMetricsTypeEnum,
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    population: number,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/exporthedismembers?type=${type}&healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&population=${population}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const getBhDiagnosticSummary = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbhdiagnosticsummary?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
export const getBhDiagnosticMembers = async (
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/getbhdiagnosticmembers?healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};

export const exportBhDiagnosticSummary = async (
    type: HedisMetricsTypeEnum,
    healthPlanIds: string,
    teamId: string,
    dateFilter: TimePeriodFilterEnum,
    dateFrom: string,
    dateTo: string,
    includePastOpenStatusMembers: boolean,
    includeInActiveTeams: boolean
) => {
    const response = await axios.get(
        `${api}/hedismetrics/exportbhdiagnositcmembers?type=${type}&healthPlanIds=${healthPlanIds}&teamId=${teamId}&dateFilter=${dateFilter}&dateFrom=${dateFrom}&dateTo=${dateTo}&includePastOpenStatusMembers=${includePastOpenStatusMembers}&includeInActiveTeams=${includeInActiveTeams}`
    );
    return response.data;
};
